import React from 'react';

import LockSharpIcon from '@material-ui/icons/LockSharp';

import { Typography } from '@mui/material';
import { GraphPreviewPropTypes } from '../../interfaces/iproptypes';
import { COLOR_PRIMARY } from 'src/const';

const getInfix = (
  parent: 'demand' | 'supply',
  variant: 'propertySize' | 'propertyType' | 'channel' | 'bookingType' | 'bookingLead'
) => {
  let infix = '';
  if (parent === 'supply') {
    switch (variant) {
      case 'propertySize':
        infix = 'of listings consist of a';
        break;
      case 'propertyType':
        infix = 'of listings are';
        break;
      case 'channel':
        infix = 'of listings are from';
        break;
      default:
        infix = 'of listings are';
        break;
    }
  } else infix = `of revenue comes from`;
  return infix;
};

const getPostfix = (
  parent: 'demand' | 'supply',
  variant: 'propertySize' | 'propertyType' | 'channel' | 'bookingType' | 'bookingLead'
) => {
  let postfix = '';

  if (parent === 'supply') {
    switch (variant) {
      case 'propertySize':
        postfix = ' property';
        break;
      case 'propertyType':
        postfix = ' properties';
        break;
      default:
        postfix = '';
        break;
    }
  } else {
    switch (variant) {
      case 'propertySize':
        postfix = ' properties';
        break;
      case 'propertyType':
        postfix = ' properties';
        break;
      default:
        postfix = '';
        break;
    }
  }
  return postfix;
};

const GraphPreview = ({
  parent,
  variant,
  useFriendlyDataName,
  previewVal,
  isDisabled,
  showAdditionalInfo,
  annualNumberOfBookings,
  cleaningFeeAnnualRevenue,
}: GraphPreviewPropTypes) => {
  const infix = getInfix(parent, variant);
  const postfix = getPostfix(parent, variant);
  return (
    <div style={{ width: '100%' }}>
      <Typography variant="body1" display="inline">
        <span style={{ fontWeight: 'bold' }}>
          {isDisabled ? <LockSharpIcon style={{ color: COLOR_PRIMARY }} /> : previewVal}
        </span>{' '}
        {infix} <span style={{ fontWeight: 'bold' }}>{useFriendlyDataName}</span>
        {postfix}.
      </Typography>
      {showAdditionalInfo && (
        <Typography variant="body1" display="inline">
          {' '}
          An average listing gets{' '}
          <span style={{ fontWeight: 'bold' }}>
            {isDisabled ? (
              <LockSharpIcon style={{ color: COLOR_PRIMARY }} />
            ) : (
              annualNumberOfBookings
            )}
          </span>{' '}
          bookings annually and generates{' '}
          <span style={{ fontWeight: 'bold' }}>
            {isDisabled ? (
              <LockSharpIcon style={{ color: COLOR_PRIMARY }} />
            ) : (
              cleaningFeeAnnualRevenue
            )}
          </span>{' '}
          from cleaning fees.
        </Typography>
      )}
    </div>
  );
};

export default GraphPreview;
